import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AutoSaveService {

  public saving: boolean = false;

  constructor() { }
}
